import React, { Component } from 'react';
import { Spinner } from '@mgc/react-components';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import PropTypes from 'prop-types';
import MapPropTypes from '../../MapPropTypes';
import selectors from '../../../selectors';
import UiActions from '../../../actions/ui';
import HelpActions from '../../../actions/help';
import JoyrideActions from '../../../actions/joyride';
import strings from '../../../strings';
import ModalBase from '../Base';
import NavLines from '../../NavLines';
import ContactForm from './ContactForm';
import './HelpModal.scss';

import packageInfo from '../../../../package.json';

class HelpModal extends Component {
    static propTypes = {
        faqs: PropTypes.arrayOf(MapPropTypes.FaqProps),
        contacts: PropTypes.arrayOf(MapPropTypes.ContactProps),
        visible: PropTypes.bool.isRequired,
        closeModal: PropTypes.func.isRequired,
        startTour: PropTypes.func.isRequired,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            visible: selectors.ui.getHelpModalVisible,
            faqs: selectors.help.getFaqs,
            contacts: selectors.help.getContacts,
            contactMessage: selectors.help.getContactMessage,
            contactSubjectIndex: selectors.help.getContactSubjectIndex,
            contactMessageInTransit:
                selectors.help.getContactMessageTransferring,
            contactMessageSent: selectors.help.getContactMessageSent,
            helpIsLoaded: selectors.help.getHelpIsLoaded,
            visibleTab: selectors.help.getVisibleTab,
        });

    static mapDispatch = (dispatch) => ({
        closeModal: () => dispatch(UiActions.closeHelpModal()),
        requestFaqs: () => dispatch(HelpActions.requestFaqs()),
        updateSubjectIndex: (index) =>
            dispatch(HelpActions.updateContactSubjectIndex(index)),
        updateMessage: (message) =>
            dispatch(HelpActions.updateContactMessage(message)),
        sendMessage: (subject, message) =>
            dispatch(HelpActions.sendContactMessage(subject, message)),
        showFaqTab: () => dispatch(HelpActions.showFaqTab()),
        showContactTab: () => dispatch(HelpActions.showContactTab()),
        showTourTab: () => dispatch(HelpActions.showTourTab()),
        startTour: () => {
            dispatch(UiActions.closeModal('help'));
            dispatch(JoyrideActions.startJoyride());
        },
        showAboutTab: () => dispatch(HelpActions.showAboutTab()),
    });

    _startJoyride(){
        setTimeout(() => {
            window.scrollTo({ top: 6, behavior: "smooth" });
          }, 100);
        this.props.startTour();
    }

    _renderFaqs() {
        return (
            <dl className="faq-list p-a-md">
                {this.props.faqs.map((faq, i) => {
                    return (
                        <span key={i}>
                            <dt>{faq.question}</dt>
                            <dd>{faq.answer}</dd>
                        </span>
                    );
                })}
            </dl>
        );
    }

    _renderContent() {
        if (!this.props.helpIsLoaded) {
            return <Spinner size="large" />;
        }

        switch (this.props.visibleTab) {
            case 'contact':
                return (
                    <ContactForm
                        contacts={this.props.contacts}
                        updateMessage={this.props.updateMessage}
                        updateSubjectIndex={this.props.updateSubjectIndex}
                        sendMessage={this.props.sendMessage}
                        message={this.props.contactMessage}
                        messageInTransit={this.props.contactMessageInTransit}
                        messageSent={this.props.contactMessageSent}
                        subjectIndex={this.props.contactSubjectIndex}
                    />
                );
            case 'tour':
                return (
                    <div className="p-a-md">
                        <p>{strings.takeTour}</p>
                        <p className="pull-right m-b-0">
                            <button
                                onClick={() => this._startJoyride()}
                                className="btn btn-info"
                            >
                                {strings.startTour}
                            </button>
                        </p>
                    </div>
                );
            case 'about':
                return (
                    <div className="p-a-md">
                        <div>
                            <strong>{strings.mentorAdvantage}</strong>
                        </div>
                        <div>
                            <strong>{strings.version}</strong>:{' '}
                            {packageInfo.version}
                        </div>
                    </div>
                );
            case 'faq':
            default:
                return this._renderFaqs();
        }
    }

    _handleTabChange(key) {
        switch (key) {
            case 'about':
                return this.props.showAboutTab();
            case 'tour':
                return this.props.showTourTab();
            case 'contact':
                return this.props.showContactTab();
            case 'faq':
            default:
                return this.props.showFaqTab();
        }
    }

    render() {
        return (
            <ModalBase
                modalClassName="help-modal"
                modalTitle={strings.help}
                visible={this.props.visible}
                closeModal={() => this.props.closeModal()}
            >
                <NavLines
                    activeTab={this.props.visibleTab}
                    onChange={(key) => this._handleTabChange(key)}
                    tabs={[
                        {
                            name: 'faq',
                            label: strings.faq,
                        },
                        {
                            name: 'contact',
                            label: strings.contact,
                        },
                        {
                            name: 'tour',
                            label: strings.tour,
                        },
                        {
                            name: 'about',
                            label: strings.about,
                        },
                    ]}
                />
                <div className="content">
                    <div className="help-container">
                        {this._renderContent()}
                    </div>
                </div>
            </ModalBase>
        );
    }
}

export default attach(HelpModal);



// WEBPACK FOOTER //
// ./app/components/Modals/HelpModal/index.jsx